var $ = require('jquery');

$('.dd-graphic__marker').each(function () {
  let $marker = $(this);
  $marker.on('click', function (event) {
    // Marker active
    $('.dd-graphic__marker').removeClass('is-active');
    $marker.toggleClass('is-active');
  });
});

$('.dd-graphic__marker').each(function () {
  let $marker = $(this);
});


var checkAnsage = $('.dd-graphic--ansage').length;
if (checkAnsage == 1) {
  $('.dd-graphic--ansage').addClass('ansage--1-is-active');

  $('.dd-graphic__marker__marker--1').on('click', function (event) {
    $('.dd-graphic--ansage').removeClass('ansage--2-is-active');
    $('.dd-graphic--ansage').addClass('ansage--1-is-active');
  });

  $('.dd-graphic__marker__marker--2').on('click', function (event) {
    $('.dd-graphic--ansage').removeClass('ansage--1-is-active');
    $('.dd-graphic--ansage').addClass('ansage--2-is-active');
  });
}
